import { header } from './header.i18n';

export const de = {
  header,
};
